module.exports = __webpack_public_path__ + "images/areamap/btn_mappin_kansai_pc_31822cd915a6640f3e3d461bc7ac86c4.png";